jQuery(document).ready(function () {

    if ($(window).width() > 1100) {

        let header = $('.header');
        let serviceSidebar = $('.service-sidebar');
        /*-- Scroll Up/Down add class --*/
        let lastScrollTop = 0;
        $(window).scroll(function () {
            var st = $(this).scrollTop();
            if (st > lastScrollTop) {
                header.addClass('header--scroll-down');
                header.removeClass('header--scroll-up');
                if (serviceSidebar) {
                    serviceSidebar.addClass('service-sidebar--scroll-down');
                    serviceSidebar.removeClass('service-sidebar--scroll-up');
                }
            } else {
                header.addClass('header--scroll-up');
                header.removeClass('header--scroll-down');
                if (serviceSidebar) {
                    serviceSidebar.removeClass('service-sidebar--scroll-down');
                    serviceSidebar.addClass('service-sidebar--scroll-up');
                }
            }

            lastScrollTop = st;
            if (st >= 300) {
                header.addClass('header--fixed');
            } else {
                header.removeClass('header--fixed');
            }
        });
    }
});
